// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1nRgI","label":"Labeled_label__2CLR7","divider":"Labeled_divider__35mNE"};